import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tsg_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function getAdminToken() {
  return localStorage.getItem("tsg_admin_token");
}
export function setAdminToken(t) {
  localStorage.setItem("tsg_admin_token", t);
}
export function clearAdminToken() {
  localStorage.removeItem("tsg_admin_token");
}
